import { Employees } from "../../models/personal/employees.model";

export class ScheduleModel {
  id: number;
  activityId: number;
  contactUid: string;
  conceptUid: string;
  title: string;
  description?: string;
  observations?: string;
  startDate: string;
  endDate: string;
  isAllDay: boolean;
  createdAt: string;
  updatedAt?: string;
}

